import { takeLatest } from 'redux-saga/effects';

import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(ACTION.GET_RETURNS.REQUEST, saga.getDeliveryNoteReturns);
}
